export default __webpack_public_path__ + "static/media/start.c8149644.mp3";